function initSocialMenu() {
  const postSocialItems = document.querySelectorAll(
    ".posts-social-nav .sub-menu .menu-item"
  );
  const postTitle = encodeURIComponent(window.wp_info.title);
  const postUrl = encodeURIComponent(window.wp_info.postUrl);

  postSocialItems.forEach((menuItem) => {
    const menuLinkTag = menuItem.querySelector("a");
    const menuLinkTitle = menuItem.querySelector("a span").textContent;
    menuLinkTag.target = "_blank";

    switch (menuLinkTitle.toLowerCase()) {
      case "facebook":
        menuLinkTag.href = `https://www.facebook.com/sharer/sharer.php?u=${postUrl}&text=${postTitle}!`;
        break;
      case "twitter":
        menuLinkTag.href = `https://twitter.com/intent/tweet?text=${postTitle}!&url=${postUrl}`;
        break;
      case "linkedin":
        menuLinkTag.href = `https://www.linkedin.com/sharing/share-offsite/?url=${postUrl}`;
        break;
      case "whatsapp":
        menuLinkTag.href = `https://wa.me/?text=${postTitle}!%5Cn%20${postUrl}`;
        break;
      case "telegram":
        menuLinkTag.href = `https://t.me/share/url?url=${postUrl}&text=${postTitle}!`;
        break;
      case "reddit":
        menuLinkTag.href = `https://www.reddit.com/submit?url=${postUrl}&title=${postTitle}!`;
        break;

      default:
        break;
    }
  });
}

window.addEventListener("DOMContentLoaded", function () {
  initSocialMenu();
});
